export default "__VITE_ASSET__CTrvLzhf__"